import FormNuevaFincaComponent from "../components/formsFinca/FormNuevaFinca";

const NuevaFincaPage = () => {
    return(
        <>
            <FormNuevaFincaComponent />
        </>
    );
}
export default NuevaFincaPage;